import { Activity, ActivityStatus } from 'app/activity/models/activity.model';
import * as _ from 'lodash';
import { ApplicationHash } from '@siq-js/core-lib';

export class IncrementalsActivity extends Activity {

  constructor(activity?: Activity) {
    super(activity);

    this.sheets = this.sheets || [];
  }

  getStatus(): ActivityStatus {
    const statusCounter = {
      running: this.sheets.filter(s => s.getStatus() === ActivityStatus.RUNNING).length,
      ready: this.sheets.filter(s => s.getStatus() === ActivityStatus.READY).length,
      error: this.sheets.filter(s =>
        [ActivityStatus.ERROR, ActivityStatus.PREVIEW_RUNNING, ActivityStatus.PREVIEW_READY].includes(s.getStatus())
      ).length,
      expired: this.sheets.filter(s => s.getStatus() === ActivityStatus.EXPIRED).length,
    };

    if (statusCounter.running > 0) return ActivityStatus.RUNNING;
    if (statusCounter.error > 0) return ActivityStatus.ERROR;
    if (this.accessGroupChanged) {
      return ActivityStatus.ALERT;
    }
    if (statusCounter.expired > 0) return ActivityStatus.EXPIRED;
    return ActivityStatus.READY;
  }

  isComplete(): boolean {
    return !_.find(this.sheets, s => s.getStatus() === ActivityStatus.RUNNING);
  }

  isReportActuallySheet(): boolean {
    return this.getAppId() === ApplicationHash.REPORT_BUILDER_SHEET;
  }

  isViewed(): boolean {
    return this.sheets.length === 0 || this.getMetaDataByKey('read') === 'true';
  }
}
